import { Component, Input } from "@angular/core";

@Component({
  selector: "app-no-record-found",
  templateUrl: "./no-record-found.component.html",
  styleUrls: ["./no-record-found.component.scss"],
})
export class NoRecordFoundComponent {
  @Input() minHeight = "auto";
  @Input() padding = "1.5rem";
  @Input() size: "xs" | "sm" | "md" = "md";
  @Input() message = "No Record(s) Found!";
  @Input() isImage = true;
}
